var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;stroke:#333333;stroke-width:0.5;stroke-miterlimit:10;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,7l5.4,5.4L10.4,28.3L5,22.9L20.8,7 M20.8,5.6L3.6,22.9l6.8,6.8l17.2-17.3L20.8,5.6L20.8,5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,1c0.5,0,1,0.2,1.4,0.6l3,3c0.5,0.5,0.5,1.4,0,1.9l-2.7,2.7L24,3.8l2.2-2.2C26.6,1.2,27.1,1,27.6,1  M27.6,0c-0.8,0-1.5,0.3-2.1,0.9l-2.9,2.9l6.8,6.8l3.4-3.4c0.9-0.9,0.9-2.4,0-3.3l-3-3C29.1,0.3,28.4,0,27.6,0L27.6,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,26.7L6.6,31l-5.5,1.3L2.3,26.7 M1.7,24.7L0,32.5c-0.1,0.5,0.3,0.9,0.8,0.9c0.1,0,0.1,0,0.2,0l7.6-1.8 L1.7,24.7L1.7,24.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditSetting);
export default __webpack_public_path__ + "static/media/icEditSetting.5d8f6b04c3d9af1e326326269da3f011.svg";
export { ForwardRef as ReactComponent };